import { useMemo } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import type { RestaurantRouteParams } from './useRestaurant';

export const useRestaurantSlugFromUrl = (): string => {
  const { restaurantSlug } = useParams<RestaurantRouteParams>();
  const matcher = useRouteMatch<RestaurantRouteParams>({ path: '/:restaurantSlug', strict: true });

  const ensuredRestaurantSlug = useMemo(() => (matcher?.params?.restaurantSlug ?? restaurantSlug), [matcher, restaurantSlug]);

  return ensuredRestaurantSlug;
};
